<template>
    <v-card
        elevation="2"
        height="100%"
        v-if="is_loaded"
    >
        <v-card-title
            class="text_primary"
        >
            模組使用數

            <v-spacer></v-spacer>

            <v-btn-toggle 
                v-model="toggle_exclusive"
                @change="changeDevice"
                mandatory
            >

                <v-btn
                >
                    <v-icon>mdi-monitor</v-icon>
                </v-btn>

                <v-btn
                >
                    <v-icon>mdi-cellphone</v-icon>
                </v-btn>

            </v-btn-toggle>

            <v-btn
                class="ml-3 btn_action btn_action_bg_linear"
                @click="getHTML"
            >
                取得嵌入程式碼
            </v-btn>
        </v-card-title>

        <div class="ml-4 mb-3">點名字或數量進行修改！</div>

        <v-card-text
            class="pa-0 pb-4"
            v-if="toggle_exclusive === 0"
        >
            <div class="tbl-col tbl-f">
                <div class='c-row span2C'>
                    <div class='c-td w2'></div>
                    <div  
                        class='c-col w2' 
                        v-for="(level, idx) in level_headers" 
                        :key="idx"
                    >
                        <div class='c-th th-f'>{{level.name}}</div>
                    
                        <div v-if="level.level !== 0" class='c-th th-f price'>${{level.add_column.price}}</div>
                        <div v-else class='c-th th-f price'>免費試用7天</div>
                    </div>
                </div>
                <template v-for="(category, idx) in categories">
                    
                    <div class='c-row' :key="`c_${idx}`">
                        <div class='c-thead wadj'>
                            <h1 class="c-h1">{{category.name}}</h1>
                        </div>
                    </div>

                   <div :key="`d_${idx}`" v-if="category.category.length > 0">
                        <template
                            v-for="(sub_category, f_idx) in category.category"
                        >
                            <div class="c-row category" 
                                :key="`f_${f_idx}`"
                            >
                                <div 
                                    class='c-td category-name w2'
                                    @click="activateDetails(sub_category.name)"
                                    :category="`${sub_category.name}`"
                                >
                                    <span class="c-arrow" > ▼ </span>
                                    {{sub_category.name}}
                                </div>

                                <template
                                    v-for="(level_quota,level_quota_idx) in sub_category.features[0].levelRemainingRes"
                                >

                                    <div  
                                        class='c-col w2' 
                                        v-if="sub_category.features[0].function.includes('Release') || sub_category.features[0].function.includes('Activate')"
                                        :key="level_quota_idx"
                                        
                                    >
                                        <div class='c-th c-td-title'>{{level_quota.remaining}}</div>
                                    </div>
                                </template>

                            </div>

                            <div 
                                :category="`${sub_category.name}`"
                                class="c-row"
                                v-for="(feature, feature_idx) in sub_category.features "
                                :key="`f4_${feature.function}_${feature_idx}`" 
                            >
                                <div 
                                    class='c-td feature-name w2' 
                                    style="cursor:pointer;"
                                    @click="editFeatureName(feature)"
                                >

                                    <span>{{feature.name}}</span>
                                    
                                    <v-tooltip right color="white" v-if="feature.memo">
                                        <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                            class="ml-2"
                                            icon
                                            x-small
                                            v-bind="attrs"
                                            v-on="on"
                                        >
                                            <v-icon
                                                color="white"
                                            >
                                                mdi-information-variant-circle
                                            </v-icon>
                                        </v-btn>
                                        </template>
                                        <span class="black--text">{{feature.memo}}</span>
                                    </v-tooltip>

                                </div>

                                <div  
                                    class="c-col w2"
                                    v-for="(level_quota, level_quota_idx) in feature.levelRemainingRes"
                                    :key="level_quota_idx"
                                    style="cursor:pointer;"
                                    @click="editQuota(feature, level_quota)"
                                >
                                    <div v-if="feature.type !== 'boolean'">{{level_quota.remaining}}</div>
                                    <div v-else>
                                        <span v-if="level_quota.remaining === 1">✅</span>
                                        <span v-else>❌</span>
                                    </div>
                                </div>


                            </div>
                        </template>

                    </div>

                   <div class="c-row" :key="`d_${idx}`" v-if="category.features && category.features.length > 0">
                        <template
                            v-for="(feature, f_idx) in category.features"
                        >

                            <div 
                                @click="editFeatureName(feature)"
                                class='c-td feature-name w2' :key="`${feature.function}_${f_idx}`">
                                {{feature.name}}
                            </div>

                            <div  
                                class="c-col w2"
                                v-for="(level_quota,level_quota_idx) in feature.levelRemainingRes"
                                :key="level_quota_idx"
                            >
                                <div class="">{{level_quota.remaining}}</div>
                            </div>

                        </template>

                    </div>
                    
                </template>

            </div>

        </v-card-text>


        <v-card-text
            v-else
        >
            <template
                v-for="(level, idx) in level_headers"
            >
                <div class="tbl-col tbl-f mt-3" :key="idx">
                    <div class='c-row mobile span2C'>
                        <div  
                            class='c-col mobile w12' 
                        >
                            <div class='c-th th-f'>{{level.name}}</div>
                        
                            <div v-if="level.level !== 0" class='c-th th-f price'>${{level.add_column.price}}</div>
                            <div v-else class='c-th th-f price'>免費試用7天</div>
                        </div>
                    </div>
                </div>
                <template v-for="(category, idx) in categories">
                    
                    <div class='c-row mobile' :key="`c_${level.level}_${idx}`">
                        <div class='c-thead wadj'>
                            <h1 class="c-h1">{{category.name}}</h1>
                        </div>
                    </div>

                   <div :key="`d_${level.level}_${idx}`" v-if="category.category.length > 0">
                        <template
                            v-for="(sub_category, f_idx) in category.category"
                        >
                            <div class="c-row mobile category" 
                                :key="`f_${f_idx}`"
                            >
                                <div 
                                    class='c-td category-name w5'
                                    @click="activateDetails(sub_category.name, level)"
                                    :category="`${sub_category.name}`"
                                >
                                    <span class="c-arrow" > ▼ </span>
                                    {{sub_category.name}}
                                </div>

                                <div  
                                    class='c-col mobile' 
                                >
                                    <div class='c-th c-td-title'>{{gogo(sub_category.features[0], level).remaining}}</div>
                                </div>
                            </div>

                            <div 
                                :category="`${sub_category.name}`"
                                class="c-row mobile"
                                v-for="(feature, feature_idx) in sub_category.features "
                                :key="`f4_${feature.function}_${feature_idx}`" 
                            >
                                <div 
                                    class='c-td feature-name w5' 
                                    style="cursor:pointer;"
                                    @click="editFeatureName(feature)"
                                >

                                    <span>{{feature.name}}</span>
                                    
                                    <v-tooltip right color="white" v-if="feature.memo">
                                        <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                            class="ml-2"
                                            icon
                                            x-small
                                            v-bind="attrs"
                                            v-on="on"
                                        >
                                            <v-icon
                                                color="white"
                                            >
                                                mdi-information-variant-circle
                                            </v-icon>
                                        </v-btn>
                                        </template>
                                        <span class="black--text">{{feature.memo}}</span>
                                    </v-tooltip>

                                </div>

                                <div  
                                    class="c-col mobile w2"
                                    style="cursor:pointer;"
                                    @click="editQuota(feature, gogo(feature,level))"
                                >
                                    <div v-if="feature.type !== 'boolean'">{{gogo(feature,level).remaining }}</div>
                                    <div v-else>
                                        <span v-if="gogo(feature,level).remaining === 1">✅</span>
                                        <span v-else>❌</span>
                                    </div>
                                </div>


                            </div>
                        </template>

                    </div>

                   <div class="c-row mobile" :key="`d_${level.level}_${idx}`" v-if="category.features && category.features.length > 0">
                        <template
                            v-for="(feature, f_idx) in category.features"
                        >

                            <div 
                                @click="editFeatureName(feature)"
                                class='c-td feature-name w5' :key="`${feature.function}_${f_idx}`">
                                {{feature.name}}
                            </div>

                            <div  
                                class="c-col mobile"
                                :key="`p_${feature.function}_${f_idx}`"
                            >
                                <div class="">{{ gogo(feature,level).remaining}}</div>
                            </div>

                        </template>

                    </div>
                </template>

            </template>

        </v-card-text>



        <v-dialog
            v-if="dialog.is_show"
            @click:outside="dialog.is_show = false"
            v-model="dialog.is_show"
            width="500"
        >

        <v-card>
            <v-card-title class="text-h5 blue white--text">
                {{dialog.title}}
            </v-card-title>

            <v-card-text class="pt-5" v-if="dialog.type === 'quota'">

                <h3>方案: {{ getLevelName(dialog.level.level) }}</h3>
                <h3>功能: {{ dialog.feature.name }}</h3>

                <div class="mt-3">
                    <v-text-field
                        v-if="dialog.feature.type === 'number'"
                        outlined
                        dense
                        hide-details
                        type="number"
                        v-model="dialog.level.remaining"
                    ></v-text-field>

                    <v-checkbox
                        v-else
                        outlined
                        dense
                        hide-details
                        v-model="dialog.level.remaining"
                        label="啟用"
                    >
                    </v-checkbox>

                </div>

            </v-card-text>

            <v-card-text class="pt-5" v-else>

                <div class="mt-3">
                    <h3>顯示名稱: </h3>
                    <v-text-field
                        outlined
                        dense
                        hide-details
                        type="text"
                        v-model="dialog.feature.name"
                    ></v-text-field>
                </div>

                <div class="mt-3">
                    <h3>備註: </h3>
                    <v-text-field
                        outlined
                        dense
                        hide-details
                        type="text"
                        v-model="dialog.feature.memo"
                    ></v-text-field>
                </div>
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
                <v-spacer></v-spacer>

                <v-btn
                    color="grey"
                    text
                    @click="dialog.is_show = false"
                >
                    取消
                </v-btn>
                <v-btn
                    color="blue"
                    text
                    @click="confirm()"
                >
                    確認
            </v-btn>
            </v-card-actions>
        </v-card>
        </v-dialog>

		<CodeCopyDialog 
			:setting="code_copy_setting"
		>

		</CodeCopyDialog>

    </v-card>
</template>
<script>
// import 子組件
import CodeCopyDialog from "@/components/Utils/CodeCopyDialog.vue";
import {
    apiGetSubscription,
    apiUpdateSubscription,
    apiUpdateFeatureName
} from '@/api/admin.js'
import {
    apiGetSubscriptionTree
} from '@/api/open.js'

export default {
    components: { 
        CodeCopyDialog 
    },
    name: "LevelUsage",
    data() {
        return {
            level_headers: [],
            categories: [],
            is_edit: false,
            is_loaded: false,
            dialog: {
                is_show: false,
                title: '',
                target_subscription: '',
                level: '',
                feature: '',
                quota:'',
                field_type: '',
                field_text: '',
            },
            subscriptions: [],
            toggle_exclusive: 0,
            code_copy_setting: {
                html_code : `<iframe style="max-width:1080px;width:100%;height:800px; border:0px;" src="${process.env.VUE_APP_USER_EMBED_ORIGIN}/subscription/plan"></iframe>`,
                is_show: false,
                title: '在頁面嵌入訂閱方案',
                subtitle: '請將這段程式碼放在網頁想要顯示的區塊中 :',
                description: '',
                width: '600'
            }
        }
    },
    methods: {
        async getData(){
            try {
                let result = await apiGetSubscriptionTree()
                console.log('result:', result)
                this.level_headers = result.level_headers
                this.categories = result.categories

                this.categories.forEach(function(category){
                    console.log(category.category)
                    if (category.features) {
                        category.features.forEach(function(feature){
                            feature.levelRemainingRes = feature.levelRemainingRes.sort((a, b) => a.level - b.level);
                        })
                    }

                    category.category.forEach(function(sub_category){
                        sub_category.features.forEach(function(feature){
                            feature.levelRemainingRes = feature.levelRemainingRes.sort((a, b) => a.level - b.level);
                        })
                    })
                })

                this.is_loaded = true

                this.subscriptions = await apiGetSubscription()
                console.log('subscriptions',this.subscriptions)

            } catch (error) {
                this.$root.vtoast.show({ 
                    message: `取得階級模組失敗: ${error}`  
                })
            }
        },
        activateDetails(category_name){
            console.log('category_name', category_name)
            let category_features = Array.from(document.querySelectorAll(`.c-row[category="${category_name}"]`))
            let category_arrow = document.querySelector(`.category-name[category="${category_name}"] > .c-arrow`)

            let is_deactivate = category_arrow.className.includes('deactivate-detail')
            if (is_deactivate) {
                category_arrow.classList.remove('deactivate-detail')
                category_arrow.innerText = '▼'
                category_features.forEach(function(category_feature){
                    category_feature.classList.remove('deactivate-detail')
                })
            }
            else {
                category_arrow.classList.add('deactivate-detail')
                category_arrow.innerText = '►'
                category_features.forEach(function(category_feature){
                    category_feature.classList.add('deactivate-detail')
                })

            }
        },
        editFeatureName(feature){
            console.log('feature', feature)
            this.dialog.title = '修改名稱'
            this.dialog.type = 'name'
            this.dialog.feature = JSON.parse(JSON.stringify(feature))
            this.dialog.is_show = true
            console.log(apiUpdateFeatureName)
        },
        async confirmFeatureName(){
            let params = {
                "target_function": this.dialog.feature.function,
                "display_name": this.dialog.feature.name,
                "memo": this.dialog.feature.memo,
            }
            console.log('params', params)
            try {
                let result = await apiUpdateFeatureName(params)
                console.log(result)
                this.$root.vtoast.show({ 
                    color: 'primary',
                    message: `更新成功`  
                })
                await this.getData()
            } catch (error) {
                this.$root.vtoast.show({ 
                    message: `更新失敗，原因: ${error}`  
                })
            }

            this.dialog.is_show = false

            console.log(params)
        },
        editQuota(feature, level){
            console.log('feature:', feature)
            console.log('level:', level.level)
            let target_subscription = this.subscriptions.find(function(subscription){
                return subscription.function === feature.function && subscription.level === level.level
            })
            console.log('subscription', target_subscription)
            if (target_subscription) {
                this.dialog.is_show = true
                this.dialog.title = '修改額度'
                this.dialog.level = JSON.parse(JSON.stringify(level))
                this.dialog.feature = feature
                this.dialog.target_subscription = target_subscription
                this.dialog.type = 'quota'
                console.log('this.dialog',this.dialog)
            }
        },
        async confirmQuota(){
            console.log(this.dialog)
            if (this.dialog.feature.type === 'boolean') {
                if (this.dialog.level.remaining === true) {
                    this.dialog.level.remaining = 1
                }
                if (this.dialog.level.remaining === false) {
                    this.dialog.level.remaining = 0
                }
            }

            if (isNaN(parseInt(this.dialog.level.remaining))) {
                return
            }

            let params = {
                "subscription_functions": [
                    {
                        "id": this.dialog.target_subscription.id,
                        "limits": parseInt(this.dialog.level.remaining)
                    }
                ]
            }

            try {
                let result = await apiUpdateSubscription(params)
                console.log(result)
                this.$root.vtoast.show({ 
                    color: 'primary',
                    message: `更新成功`  
                })
                await this.getData()
            } catch (error) {
                this.$root.vtoast.show({ 
                    message: `更新失敗，原因: ${error}`  
                })
            }

            this.dialog.is_show = false

            console.log(params)
        },
        confirm(){
            if (this.dialog.type === 'quota') {
                this.confirmQuota()
            }
            else {
                this.confirmFeatureName()
            }
        },
        getLevelName(level) {
            let target = this.level_headers.find(function(level_header){
                return level_header.level === level
            })
            return target.name
        },
        changeDevice(event){
            console.log(event)
        },
        gogo(feature, level){
            let level_quota = feature.levelRemainingRes.find(function(levelRemaining){
                return levelRemaining.level === level.level
            })
            return level_quota
        },
        getHTML(){
            this.code_copy_setting.is_show = true
        }
    },
    created: async function(){
        try {
            await this.getData()
        } catch (error) {
            console.log('error:',error)
            this.$root.vtoast.show({ 
                message: `取得階級模組失敗: ${error}`  
            })
        }
    },
    computed: {
    },
    mounted() {
    }
}
</script>
<style scoped>
.right-align >>> input {
    text-align: right !important;
}
.center-align {
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>

<style scoped>
.level-wrapper {
    background-color: #000;
}
.tbl-col {
    display: flex;
    flex-flow: column nowrap;  
    overflow: auto;
    margin: auto;
}
.tbl-f{
    font-size: 95%;
    min-width: 30em;
    width: 100%;
}
.c-col{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}
.c-col.mobile {
    flex:1;
}
.c-row {
    background-color:#343434;
    color: white;
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.c-row.mobile {
    justify-content: left;
}
.c-row.category {
    border-bottom: 1px #FFFFFF solid;
}
/* .c-row:nth-child(2n) {  
    background-color:#2c2c2c;
}
.c-row:nth-child(2n+1) {  
    background-color:#343434;color: white;
} */
.c-th, .c-td, .c-thead {
    display: flex;
    align-items: center;
    border: 0;
    flex-shrink: 0;
}
.c-td {
    justify-content: center;
    height: 3.5em;
}
.c-td.category-name {
    justify-content: left;
    cursor: pointer;
    font-weight: bold;
}
.c-td.feature-name {
    justify-content: left;
    padding-left: 10px;
}
.w3 {
    width: 24%;
}
.w1 {
    width: 8.33%;
}
.w2 {
    width: 16.66%;
}
.w4 {
    width: 33.32%;
}
.w5 {
    width: 41.65%;
}
.w12 {
    width: 100%;
}
.th-f.price {
    font-size: 100%;
}
.c-input {
    color: #FFF;
    text-align: center;
}
/** table header start */
.span2C {
    height: 6em;
    padding: 20px 0 0 0;
    background-image: linear-gradient(37deg, #BF8B2A, #EAC677, #F2D785, #F2D06B, #BF8B2A);
}
.th-f {
    font-size: 140%;
    text-align: center;
    color: #000000;
    font-weight: bold;
}
.c-td-title {
    font-size: 110%;
    text-align: center;
    color: #FFFFFF;
    font-weight: bold;
}
/** table feature category */
.c-thead{ 
    background-image: linear-gradient(90deg, #F2D06B, #F2D785, #F2D06B);
    justify-content: flex-start;
    height: 3em;
    color: #000000;
    border-top:1px solid #BF8B2A;
}
.wadj { 
    flex-grow:1; 
}
.c-h1 {
    font-size: 110%;
    margin: 0;
    padding: 0;
    padding-left:10px;
}
/** 功能 */
.c-title {
    font-weight: bold;
    
}
.c-subtitle {
    justify-content: flex-start; 
    border-right: 1px solid #000;
    font-weight: bold;
}
.c-arrow {
    padding:0px 10px;
}
.c-row.deactivate-detail {
    display: none;
}
</style>